import i18next from '../../config';
import { harmFilterSet, productFilterSet, lawFilterSet } from './stringFilters';
import { applicationEnum, productEnum, stringEnum, agencyEnum } from './sharedStrings.types';

// Function to fetch localized strings based on arguments.
export function getLocalizedStrings(desiredStrings: stringEnum, application: applicationEnum, agency?: agencyEnum | null, product?: string | null): Record<string, string> {
  let keys: string[] = [];

  let desiredFilterSet;
  switch (desiredStrings) {
    case stringEnum.harms:
      desiredFilterSet = harmFilterSet;
      break;
    case stringEnum.products:
      desiredFilterSet = productFilterSet;
      break;
    default:
      desiredFilterSet = lawFilterSet;
  }

  // Narrow down by application to get the application filter for the desired strings.
  const applicationFilter = desiredFilterSet.application[applicationEnum[application]];

  // If we have passed in an agency argument, also use the agency filter.
  if (agency) {
    const agencyFilter = desiredFilterSet.agency[agencyEnum[agency]];
    keys = applicationFilter.filter(value => agencyFilter?.includes(value));
  } else {
    keys = applicationFilter;
  }

  // If we have passed in a product argument and are looking for a harms list, also use the product filter.
  if (product && desiredStrings === stringEnum.harms) {
    const productFilter = harmFilterSet.product[product as keyof typeof productEnum];
    keys = keys.filter(value => productFilter?.includes(value));
  }

  const localizedStrings: Record<string, string> = {};

  // Do not localize product names; sort alphabetically by display name
  if (desiredStrings === stringEnum.products) {
    keys.forEach((key) => {
      const value = productEnum[key as unknown as keyof typeof productEnum];
      if (value !== undefined) {
        localizedStrings[key] = value;
      }
    });
    const sorted: Record<string, string> = {};
    Object.entries(localizedStrings)
      .sort(([, a], [, b]) => a.localeCompare(b))
      .forEach(([key, value]) => { sorted[key] = value; });
    return sorted;
  }
  keys.forEach((key) => {
    localizedStrings[key] = i18next.t(`SharedStrings.${stringEnum[desiredStrings]}.${key}`);
  });

  return localizedStrings;
}